import { render } from "./GaucherLeukocytes.vue?vue&type=template&id=618f63a0&scoped=true"
import script from "./GaucherLeukocytes.vue?vue&type=script&lang=js"
export * from "./GaucherLeukocytes.vue?vue&type=script&lang=js"

import "./GaucherLeukocytes.vue?vue&type=style&index=0&id=618f63a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618f63a0"]])

export default __exports__